import { useCallback } from "react";

import { EpisodeOfCare } from "@medplum/fhirtypes";

import { UseFormReturnType } from "@mantine/form";

type FormValuesWithEpisodeOfCare = {
  episodeOfCare?: Pick<EpisodeOfCare, "resourceType" | "id"> | undefined;
};

/**
 * Connects Mantine form state to {@link EpisodeOfCareSearchInput} (single selection from array onChange).
 *
 * @param form - Mantine form with an `episodeOfCare` field
 * @returns Input props and onChange handler for EpisodeOfCareSearchInput
 */
export function useEpisodeOfCareAutocompleteField<T extends FormValuesWithEpisodeOfCare>(
  form: Pick<UseFormReturnType<T>, "setFieldValue" | "getInputProps">,
) {
  const handleEpisodeOfCareChange = useCallback(
    (value: EpisodeOfCare[]) => {
      const setEpisodeOfCare = form.setFieldValue as (
        field: "episodeOfCare",
        value: EpisodeOfCare | undefined,
      ) => void;
      setEpisodeOfCare("episodeOfCare", value[0]);
    },
    [form],
  );

  return {
    episodeOfCareInputProps: form.getInputProps("episodeOfCare"),
    handleEpisodeOfCareChange,
  };
}
